import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

export const CHARGEBACK_FAILURE = 'CHAREGEBACK/CHARGEBACK_FAILURE';
export const CHARGEBACK_LOAD = 'CHARGEBACK/CHARGEBACK_LOAD';
export const CHARGEBACK_SUCCESS = 'CHARGEBACK/CHARGEBACK_SUCCESS';

export const DISPUTE_CHARGEBACK_FAILURE = 'CHAREGEBACK/DISPUTE_CHARGEBACK_FAILURE';
export const DISPUTE_CHARGEBACK_LOAD = 'CHARGEBACK/DISPUTE_CHARGEBACK_LOAD';
export const DISPUTE_CHARGEBACK_SUCCESS = 'CHARGEBACK/DISPUTE_CHARGEBACK_SUCCESS';

export const DISPUTES_FAILURE = 'CHAREGEBACK/DISPUTES_FAILURE';
export const DISPUTES_LOAD = 'CHARGEBACK/DISPUTES_LOAD';
export const DISPUTES_SUCCESS = 'CHARGEBACK/DISPUTES_SUCCESS';

export const DISPUTE_FAILURE = 'CHAREGEBACK/DISPUTE_FAILURE';
export const DISPUTE_LOAD = 'CHARGEBACK/DISPUTE_LOAD';
export const DISPUTE_SUCCESS = 'CHARGEBACK/DISPUTE_SUCCESS';

export const DISPUTE_PDF_FAILURE = 'CHAREGEBACK/DISPUTE_PDF_FAILURE';
export const DISPUTE_PDF_LOAD = 'CHARGEBACK/DISPUTE_PDF_LOAD';
export const DISPUTE_PDF_SUCCESS = 'CHARGEBACK/DISPUTE_PDF_SUCCESS';

export const PREVIEW_PDF_FAILURE = 'CHAREGEBACK/PREVIEW_PDF_FAILURE';
export const PREVIEW_PDF_LOAD = 'CHARGEBACK/PREVIEW_PDF_LOAD';
export const PREVIEW_PDF_SUCCESS = 'CHARGEBACK/PREVIEW_PDF_SUCCESS';

export function getChargebackFailureActionCreator(error) {
    return {
        error,
        type: CHARGEBACK_FAILURE
    };
}

export function getChargebackSuccessActionCreator(chargeback) {
    return {
        chargeback,
        type: CHARGEBACK_SUCCESS
    };
}

export function getChargeback(chargebackId) {
    return {
        failureActionTypeOrCreator: getChargebackFailureActionCreator,
        fetchParams: {
            url: `${config.chargebackApiUrl}/${chargebackId}`
        },
        loadActionTypeOrCreator: CHARGEBACK_LOAD,
        successActionTypeOrCreator: getChargebackSuccessActionCreator
    };
}

export function readImage(image) {
    return new Promise((resolve) => {
        if (!(image instanceof File)) {
            return resolve(image);
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            const imageData = { data: reader.result, name: image.name };
            resolve(imageData);
        };
        reader.readAsDataURL(image);
    });
}

export function previewDisputeChargeback(userName, chargeback, description, images, dispatch) {
    const imagePromises = images.map((image) => readImage(image));

    return Promise.all(imagePromises).then((imageDataArray) => {
        dispatch({
            failureActionTypeOrCreator: createPreviewDisputePDFFailureActionCreator(chargeback.id),
            fetchParams: {
                body: {
                    chargeback,
                    chargebackId: chargeback.id,
                    description,
                    images: imageDataArray,
                    isPreview: true,
                    userName
                },
                method: 'POST',
                url: `${config.chargebackApiUrl}/dispute`
            },
            loadActionTypeOrCreator: createPreviewDisputePDFLoadActionCreator(chargeback.id),
            successActionTypeOrCreator: createPreviewDisputePDFSuccessActionCreator(chargeback.id)
        });
    });
}

export function createPreviewDisputePDFLoadActionCreator(chargebackId) {
    return () => ({
        chargebackId,
        type: PREVIEW_PDF_LOAD
    });
}

export function createPreviewDisputePDFSuccessActionCreator(chargebackId) {
    return (previewPdf) => ({
        previewPdf,
        chargebackId,
        type: PREVIEW_PDF_SUCCESS
    });
}

export function createPreviewDisputePDFFailureActionCreator(chargebackId) {
    return (error) => ({
        error,
        chargebackId,
        type: PREVIEW_PDF_FAILURE
    });
}

export function disputeChargeback(userName, chargeback, description, images, dispatch) {
    const imagePromises = images.map((image) => readImage(image));

    return Promise.all(imagePromises).then((imageDataArray) => {
        dispatch({
            failureActionTypeOrCreator: disputeChargebackFailureActionCreator,
            fetchParams: {
                body: {
                    chargebackId: chargeback.id,
                    description,
                    images: imageDataArray,
                    userName
                },
                method: 'POST',
                url: `${config.chargebackApiUrl}/dispute`
            },
            loadActionTypeOrCreator: DISPUTE_CHARGEBACK_LOAD,
            successActionTypeOrCreator: disputeChargebackSuccessActionCreator
        });
    });
}

export function disputeChargebackFailureActionCreator(error) {
    return {
        error,
        type: DISPUTE_CHARGEBACK_FAILURE
    };
}

export function disputeChargebackSuccessActionCreator(fax) {
    return {
        fax,
        type: DISPUTE_CHARGEBACK_SUCCESS
    };
}

export function getDisputeFailureActionCreator(error) {
    return {
        error,
        type: DISPUTE_FAILURE
    };
}

export function getDisputeSuccessActionCreator(dispute) {
    return {
        dispute,
        type: DISPUTE_SUCCESS
    };
}

export function getDispute(disputeId) {
    return {
        failureActionTypeOrCreator: getDisputeFailureActionCreator,
        fetchParams: {
            url: `${config.chargebackApiUrl}/dispute/${disputeId}`
        },
        loadActionTypeOrCreator: DISPUTE_LOAD,
        successActionTypeOrCreator: getDisputeSuccessActionCreator
    };
}

export function getDisputesFailureActionCreator(error) {
    return {
        error,
        type: DISPUTES_FAILURE
    };
}

export function getDisputesSuccessActionCreator(results) {
    return {
        count: results.count,
        disputes: results.rows,
        pages: Math.ceil(results.count / results.limit),
        type: DISPUTES_SUCCESS
    };
}

export function getDisputes(chargebackId, merchantIds) {
    const queryParamsString = createQueryParams({
        filters: [{ id: 'chargebackId', value: chargebackId }],
        merchantIds,
        page: 0,
        pageSize: 10,
        sorters: []
    });

    return {
        failureActionTypeOrCreator: getDisputesFailureActionCreator,
        fetchParams: {
            url: `${config.chargebackApiUrl}/dispute${queryParamsString}`
        },
        loadActionTypeOrCreator: DISPUTES_LOAD,
        successActionTypeOrCreator: getDisputesSuccessActionCreator
    };
}

export function getDisputePDF(chargebackId, merchantId) {
    return {
        failureActionTypeOrCreator: createGetDisputePDFFailureActionCreator(chargebackId),
        fetchParams: {
            url: `${config.pdfApiUrl}/dispute/${chargebackId}?merchantIds=${merchantId}`
        },
        loadActionTypeOrCreator: createGetDisputePDFLoadActionCreator(chargebackId),
        successActionTypeOrCreator: createGetDisputePDFSuccessActionCreator(chargebackId)
    };
}

export function createGetDisputePDFLoadActionCreator(chargebackId) {
    return () => ({
        chargebackId,
        type: DISPUTE_PDF_LOAD
    });
}

export function createGetDisputePDFSuccessActionCreator(chargebackId) {
    return (disputePdf) => ({
        disputePdf,
        chargebackId,
        type: DISPUTE_PDF_SUCCESS
    });
}

export function createGetDisputePDFFailureActionCreator(chargebackId) {
    return (error) => ({
        error,
        chargebackId,
        type: DISPUTE_PDF_FAILURE
    });
}
